import React from 'react';

const ObrazekBezAni = (props) => {
    return (
        <div className={`${props.inneStyle ? props.stylizacja : 'absolute w-1/2 h-screen left-1/2'}`} style={{
            backgroundImage: `url(${props.src})`,
            backgroundSize: `${props.cover ? 'cover' : 'contain'}`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        }}>
        </div>
    );
}

export default ObrazekBezAni;
